module.exports = __webpack_public_path__ + "img/Enlaces-de-Interes.ba27b7d9.svg";